import React, { createContext, useState, useEffect } from "react";
import getObservationsByPatient from "../../utils/services/Observations/getObservationsByPatient";
import insertObservation from "../../utils/services/Observations/insertObservation";
import updateObservationStatus from "../../utils/services/Observations/updateObservationStatus";
import { useValidToken } from "../../hooks/useValidToken";

export const ObservationContext = createContext();

export const ObservationProvider = ({ children }) => {
  const [observations, setObservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cipId, setCipId] = useState(null);
  const [error, setError] = useState(null);
  const { isValid, authLoading } = useValidToken();

  // Cargar observaciones al cambiar el paciente
  useEffect(() => {
    const fetchData = async () => {
      if (authLoading || !isValid || !cipId) return;

      setLoading(true);
      setError(null);
      try {
        const data = await getObservationsByPatient(cipId);
        setObservations(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Observation fetch error:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading, isValid, cipId]);

  const reloadObservations = async (cip = cipId) => {
    if (!cip || authLoading || !isValid) return;
  
    setLoading(true);
    setError(null);
  
    try {
      const data = await getObservationsByPatient(cip);
      setObservations(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Reload observation error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  // Agregar observación
  const addObservation = async (newObservation) => {
    if (authLoading || !isValid) return;
  
    try {
      await insertObservation(newObservation);
      await reloadObservations(newObservation.cipId);
      setCipId((prev) => prev);
    } catch (err) {
      console.error("Observation insert error:", err);
      setError(err);
    }
  };

  // Actualizar estado
  const changeObservationStatus = async (updateData) => {
    if (authLoading || !isValid) return;
  
    try {
      await updateObservationStatus(updateData);
      await reloadObservations();
      setCipId((prev) => prev);
    } catch (err) {
      console.error("Observation status update error:", err);
      setError(err);
    }
  };

  return (
    <ObservationContext.Provider
      value={{
        observations,
        loading,
        error,
        cipId,
        setCipId,
        addObservation,
        changeObservationStatus,
        reloadObservations,
      }}
    >
      {children}
    </ObservationContext.Provider>
  );
};
